import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CreditRegisterInfoAction,
  CreditRegisterInfoViewModel,
} from '../credit-register-modal.model';

@Component({
  standalone: true,
  selector: 'app-modal-credit-register-info',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-credit-register-info.component.html',
  styleUrls: ['./modal-credit-register-info.component.scss'],
})
export class ModalCreditRegisterInfoComponent {
  @Input() open = false;
  @Input() viewModel: CreditRegisterInfoViewModel = {
    title: 'Atenção',
    message: '',
    icon: 'info',
    iconTone: 'info',
  };

  @Output() action = new EventEmitter<CreditRegisterInfoAction>();

  onModalDismiss(): void {
    this.action.emit('dismiss');
  }

  onConfirm(): void {
    this.action.emit('dismiss');
  }
}
